/* global localStorage */
import { createRequestActions } from 'actions';
import * as types from 'constants/ActionTypes.js';
import { ROOT_URL } from 'constants/Config.js';
import axios from 'axios';

export const loadProfile = createRequestActions({
  type: 'LOAD_PROFILE',
  url: '/user/profile',
});

export const updateProfile = createRequestActions({
  type: 'UPDATE_PROFILE',
  url: '/user/update',
  method: 'post',
});

export const createProfile = createRequestActions({
  type: 'CREATE_PROFILE',
  url: '/user/create',
  method: 'post',
});

export const loadAgentProfile = createRequestActions({
  type: 'LOAD_AGENT_PROFILE',
  url: '/user/profile',
});

export const updateAgentProfile = createRequestActions({
  type: 'UPDATE_AGENT_PROFILE',
  url: '/user/update',
  method: 'post',
});

export const loadCompanyProfiles = createRequestActions({
  type: 'LOAD_COMPANY_PROFILES',
  url: '/user/agency/list',
});

export const deleteProfile = createRequestActions({
  type: 'DELETE_PROFILE',
  url: '/user/agent/delete',
  method: 'post',
});

export const loadCompany = createRequestActions({
  type: 'LOAD_COMPANY',
  url: '/user/agency/get',
});

export const updateCompany = createRequestActions({
  type: 'UPDATE_COMPANY',
  url: '/user/create/agency',
  method: 'post',
});

export const uploadPhoto = createRequestActions({
  type: 'UPLOAD_PHOTO',
  url: '/image/upload',
  method: 'post',
});

export const uploadAgentPhoto = createRequestActions({
  type: 'UPLOAD_AGENT_PHOTO',
  url: '/image/upload',
  method: 'post',
});

export function uploadLogo(data) {
  return dispatch => {
    dispatch({ type: types.UPLOAD_LOGO_REQUEST, data: 'adfadfadfadfa' });
    return axios.post(`${ROOT_URL}/image/upload`, data)
      .then((res) => {
        dispatch({ type: types.UPLOAD_LOGO_OK, payload: { response: res.data.data } });
        return res.data.data;
      })
      // .then((res) => {
      //   return axios.post(`${ROOT_URL}/user/update`, { avatarId: res.imageId });
      // })
      .catch(error => {
        dispatch({ type: types.UPLOAD_LOGO_ERROR, payload: error });
      });
  }
}



// WEBPACK FOOTER //
// ./src/actions/profile.js